import React, { PureComponent } from 'react';
import { ButtonV2 } from '@zola/zola-ui/src/components/Button';
import PropTypes from 'prop-types';
import featureFlags from '../../../../../util/featureFlags';

// Assets
import ProofOrderIcon from '../../../../../assets/images/invitations/paper-matching.svg';

// Styles
import './ProofOrderModal.less';

class ProofOrderModal extends PureComponent {
  constructor(props) {
    super(props);

    this.handleAddingToCart = this.handleAddingToCart.bind(this);

    this.state = {
      isAddingToCart: false,
    };
  }

  handleAddingToCart() {
    const { handleProofOrderToCart } = this.props;
    this.setState({ isAddingToCart: true }, () => handleProofOrderToCart());
  }

  render() {
    const { hasEnvelope, orderDetails } = this.props;
    const { isAddingToCart } = this.state;
    const descriptionText =
      featureFlags.get('singleSampleEnvelopes') && hasEnvelope
        ? 'Order a printed proof of your card to make sure it looks just right (and get a free matching sample of an addressed envelope, too!). We’ll save your work for easy editing and ordering when you’re ready.'
        : 'Order a printed proof of your card to make sure it looks just right. We’ll save your work for easy editing and ordering when you’re ready.';
    const orderDetailsRows =
      orderDetails &&
      orderDetails.map(item => (
        <tr key={item.name}>
          <td>{item.name}</td>
          <td>{item.qty}</td>
          <td>{item.total}</td>
        </tr>
      ));
    return (
      <div className="proof-order-modal">
        <div className="modal-header">
          <div className="header-info hidden-xs">
            <img src={ProofOrderIcon} alt="Order a printed proof of your card" />
            <ul>
              <li>
                <span>Printed Proof</span>
              </li>
              <li>
                <p>{descriptionText}</p>
              </li>
            </ul>
          </div>
          <div className="header-info-mobile visible-xs">
            <ul>
              <li>
                <img src={ProofOrderIcon} alt="Order a printed proof of your card" />
                <span>Printed Proof</span>
              </li>
              <li>
                <p>{descriptionText}</p>
              </li>
            </ul>
          </div>
        </div>
        <div className="modal-body">
          <table className="table">
            <thead>
              <tr>
                <th>
                  <span>item</span>
                </th>
                <th>
                  <span>qty</span>
                </th>
                <th>
                  <span>price</span>
                </th>
              </tr>
            </thead>
            <tbody>{orderDetailsRows}</tbody>
          </table>
        </div>
        <div className="modal-footer">
          <ButtonV2 disabled={isAddingToCart} onClick={() => this.handleAddingToCart()}>
            {isAddingToCart ? 'processing...' : 'Proceed To Checkout'}
          </ButtonV2>
        </div>
      </div>
    );
  }
}

ProofOrderModal.propTypes = {
  handleProofOrderToCart: PropTypes.func,
  hasEnvelope: PropTypes.bool,
  orderDetails: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      qty: PropTypes.number,
      total: PropTypes.string,
    })
  ),
};

export default ProofOrderModal;
